import echart from 'echarts';
import { config } from '@/views/home/chartJs/chartCommon';

//获取3d丙图的最高扇区的高度
function getHeight3D(series, height) {
  series.sort((a, b) => {
    return b.pieData.value - a.pieData.value;
  });
  let pieDataValue = series[0].pieData.value
  if (series[0].pieData.value < 10) {
    pieDataValue = pieDataValue * 10
  }
  let tmp = (height * 25) / pieDataValue;
  console.log(height, tmp, series);
  // if (tmp >= 1) tmp = 50;
  return tmp;
}

// 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
function getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
  // 计算
  let midRatio = (startRatio + endRatio) / 2;
  let startRadian = startRatio * Math.PI * 2;
  let endRadian = endRatio * Math.PI * 2;
  let midRadian = midRatio * Math.PI * 2;
  // 如果只有一个扇形，则不实现选中效果。
  if (startRatio === 0 && endRatio === 1) {
    isSelected = false;
  }
  // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
  k = typeof k !== 'undefined' ? k : 1 / 3;
  // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
  let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
  let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
  // 计算高亮效果的放大比例（未高亮，则比例为 1）
  let hoverRate = isHovered ? 1.05 : 1;
  // 返回曲面参数方程
  return {
    u: {
      min: -Math.PI,
      max: Math.PI * 3,
      step: Math.PI / 32,
    },
    v: {
      min: 0,
      max: Math.PI * 2,
      step: Math.PI / 20,
    },
    x: function (u, v) {
      if (u < startRadian) {
        return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
    },
    y: function (u, v) {
      if (u < startRadian) {
        return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
    },
    z: function (u, v) {
      if (u < -Math.PI * 0.5) {
        return Math.sin(u);
      }
      if (u > Math.PI * 2.5) {
        return Math.sin(u) * h * 0.1;
      }
      return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
    },
  };
}

function fomatFloat(num, n) {
  var f = parseFloat(num);
  if (isNaN(f)) {
    return false;
  }
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
  var s = f.toString();
  var rs = s.indexOf('.');
  //判定如果是整数，增加小数点再补0
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + n) {
    s += '0';
  }
  return s;
}

export default function drawPie(data, internalDiameterRatio = 0, chart, colors = ['#00C9FF', '#0078FF', '#FCF5C2']) {
  let { fontColor, fontSize, barColor, barColorOpacity, barLineBasicColor, tooltip, xAxis } = config;
  let pieData = data;

  function getColor(c1, c2) {
    return {
      type: 'linear',
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        {
          offset: 0,
          color: c1, // 0% 处的颜色
        },
        {
          offset: 1,
          color: c2, // 100% 处的颜色
        },
      ],
    };
  }

  let color = [
    getColor('#4bb1ff', '#0e69bf'),
    getColor('#5586d4', '#22437c'),
    getColor('#75caa8', '#4e9772'),
    getColor('#40f1fc', '#208da2'),
    getColor('#5e89aa', '#addafb'),
    getColor('#f1e26d', '#c9b04e'),
  ];

  let series = [];
  let sumValue = 0;
  let startValue = 0;
  let endValue = 0;
  let legendData = [];
  let legendBfb = [];
  let k = 1 - internalDiameterRatio;
  pieData.sort((a, b) => {
    return b.value - a.value;
  });
  // 为每一个饼图数据，生成一个 series-surface 配置
  for (let i = 0; i < pieData.length; i++) {
    sumValue += pieData[i].value;
    let seriesItem = {
      name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
      type: 'surface',
      parametric: true,
      wireframe: {
        show: false,
      },
      pieData: pieData[i],
      pieStatus: {
        selected: !i ? true : false,
        hovered: false,
        k: k,
      },
      center: ['0%', '0%'],
      itemStyle: {
        opacity: 1,
        color: colors[i],
      },
      shading: 'realistic',
      realisticMaterial: {
        detailTexture: '',
        normalTexture: '',
        roughness: 0.2,
      },
    };

    // if (typeof pieData[i].itemStyle != 'undefined') {
    //   let itemStyle = {};
    //   typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
    //   typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : .5;
    //   seriesItem.itemStyle = itemStyle;
    // }

    series.push(seriesItem);
  }

  // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
  // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
  legendData = [];
  legendBfb = [];
  for (let i = 0; i < series.length; i++) {
    endValue = startValue + series[i].pieData.value;
    series[i].pieData.startRatio = startValue / sumValue;
    series[i].pieData.endRatio = endValue / sumValue;
    series[i].parametricEquation = getParametricEquation(
      series[i].pieData.startRatio,
      series[i].pieData.endRatio,
      false,
      false,
      k,
      series[i].pieData.value,
    );
    startValue = endValue;
    // let bfb = fomatFloat(series[i].pieData.value / sumValue, 4);
    let bfb = series[i].pieData.value;
    legendData.push({
      name: series[i].name,
      value: bfb,
    });
    legendBfb.push({
      name: series[i].name,
      value: bfb,
    });
  }
  let boxHeight = getHeight3D(series, 24); //通过传参设定3d饼/环的高度，26代表26px
  console.log(boxHeight, '-boxH');
  let pieOption = {
    // title: {
    //   show: false,
    //   text: '饼图程序调用高亮示例',
    //   left: 'center',
    // },
    // width: '45%',
    //
    color,
    legend: {
      show: false,
      // data: legendData,
      // orient: 'horizontal',
      // width: '30%',
      // right: 0,
      // top: 10,
      // itemGap: 10,
      // textStyle: {
      //   color: '#dcdcdc',
      //   fontSize
      // },
      // icon: "square",
      // itemWidth: 15,
      // itemHeight: 11,
      // formatter: (param) => {
      //   let item = legendBfb.filter(item => item.name == param)[0];
      //   console.log(item, param)
      //   let bfs = item.value;
      //   // let bfs = fomatFloat(item.value * 100, 2) + "%";
      //   return `${item.name}  ${bfs}`;
      // }
    },
    // labelLine: {
    //   show: true,
    //   lineStyle: {
    //     color: '#7bc0cb'
    //   }
    // },
    // label: {
    //   show: true,
    //   position: 'outside',
    //   rich: {
    //     b: {
    //       color: '#7bc0cb',
    //       fontSize: 12,
    //       lineHeight: 20
    //     },
    //     c: {
    //       fontSize: 16,
    //     },
    //   },
    //   formatter: '{b|{b} \n}{c|{c}}{b|  亩}',
    // },
    tooltip: {
      formatter: (params) => {
        if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
          let bfb = (
            (pieOption.series[params.seriesIndex].pieData.endRatio -
              pieOption.series[params.seriesIndex].pieData.startRatio) *
            100
          ).toFixed(2);
          return (
            `${params.seriesName}<br/>` +
            `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` +
            `${bfb}%`
          );
        }
      },
    },
    xAxis3D: {
      min: -1,
      max: 1,
    },
    yAxis3D: {
      min: -1,
      max: 1,
    },
    zAxis3D: {
      min: -1,
      max: 1,
    },
    grid3D: {
      show: false,
      boxHeight: boxHeight, //圆环的高度
      viewControl: {
        //3d效果可以放大、旋转等，请自己去查看官方配置
        alpha: 17, //角度
        distance: 265, //调整视角到主体的距离，类似调整zoom
        rotateSensitivity: 1, //设置为0无法旋转
        zoomSensitivity: 0, //设置为0无法缩放
        panSensitivity: 0, //设置为0无法平移
        autoRotate: false, //自动旋转
      },
    },
    series,
    // series: [
    //   {
    //     name: '',
    //     type: 'pie',
    //     radius: bool ? ['40%', '100%'] : ['40%', '70%'],
    //     // radius: '55%',
    //     center: ['50%', '50%'],
    //     label: {
    //       normal: {
    //         position: 'inner',
    //         show: false,
    //       },
    //     },
    //     selectedMode: true,
    //     selectedOffset: 10,
    //     data: pieData,
    //     emphasis: {
    //       // scaleSize: 15,//放大效果
    //       itemStyle: {
    //         // borderColor: 'rgb(255,255,255)',
    //         // borderWidth: 3,
    //       },
    //     },
    //   },
    // ],
  };
  // console.log("pieOption", pieOption)
  // console.log(pieOption, '-o')
  chart ? bindListen(chart, pieOption) : '';

  // app.currentIndex = -1;
  // let myChart = chart;
  // setInterval(() => {
  //   var dataLen = pieOption.series[0].data.length;
  //   // 取消之前高亮的图形
  //   myChart.dispatchAction({
  //     type: 'downplay',
  //     seriesIndex: 0,
  //     dataIndex: app.currentIndex,
  //   });
  //   app.currentIndex = (app.currentIndex + 1) % dataLen;
  //
  //   // 高亮当前图形
  //   myChart.dispatchAction({
  //     type: 'highlight',
  //     seriesIndex: 0,
  //     dataIndex: app.currentIndex,
  //   });
  //
  //   // 显示 tooltip
  //   myChart.dispatchAction({
  //     type: 'showTip',
  //     seriesIndex: 0,
  //     dataIndex: app.currentIndex,
  //   });
  //
  //   myChart.dispatchAction({
  //     type: 'legendScroll',
  //     scrollDataIndex: app.currentIndex,
  //     legendId: 'stock-model',
  //   });
  // }, 1000);

  return pieOption;
}

function bindListen(myChart, initOption) {
  // 监听鼠标事件，实现饼图选中效果（单选），近似实现高亮（放大）效果。
  let that = this;
  let selectedIndex = '';
  let hoveredIndex = '';

  if (!myChart) return;
  myChart.setOption(initOption);

  // 监听点击事件，实现选中效果（单选）
  myChart.on('click', function (params) {
    // 从 option.series 中读取重新渲染扇形所需的参数，将是否选中取反。
    let option = myChart.getOption()
    let isSelected = !option.series[params.seriesIndex].pieStatus.selected;
    let isHovered = option.series[params.seriesIndex].pieStatus.hovered;
    let k = option.series[params.seriesIndex].pieStatus.k;
    let startRatio = option.series[params.seriesIndex].pieData.startRatio;
    let endRatio = option.series[params.seriesIndex].pieData.endRatio;
    // 如果之前选中过其他扇形，将其取消选中（对 option 更新）
    if (selectedIndex !== '' && selectedIndex !== params.seriesIndex) {
      option.series[selectedIndex].parametricEquation = getParametricEquation(
        option.series[selectedIndex].pieData.startRatio,
        option.series[selectedIndex].pieData.endRatio,
        false,
        false,
        k,
        option.series[selectedIndex].pieData.value,
      );
      option.series[selectedIndex].pieStatus.selected = false;
    }
    // 对当前点击的扇形，执行选中/取消选中操作（对 option 更新）
    option.series[params.seriesIndex].parametricEquation = getParametricEquation(
      startRatio,
      endRatio,
      isSelected,
      isHovered,
      k,
      option.series[params.seriesIndex].pieData.value,
    );
    option.series[params.seriesIndex].pieStatus.selected = isSelected;
    // 如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
    isSelected ? (selectedIndex = params.seriesIndex) : null;
    // 使用更新后的 option，渲染图表
    myChart.setOption(option);
  });
  // 监听 mouseover，近似实现高亮（放大）效果
  myChart.on('mouseover', function (params) {
    let option = myChart.getOption()
    // 准备重新渲染扇形所需的参数
    let isSelected;
    let isHovered;
    let startRatio;
    let endRatio;
    let k;
    // 如果触发 mouseover 的扇形当前已高亮，则不做操作
    if (hoveredIndex === params.seriesIndex) {
      return;
      // 否则进行高亮及必要的取消高亮操作
    } else {
      // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
      if (hoveredIndex !== '') {
        // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
        isSelected = option.series[hoveredIndex].pieStatus.selected;
        isHovered = false;
        startRatio = option.series[hoveredIndex].pieData.startRatio;
        endRatio = option.series[hoveredIndex].pieData.endRatio;
        k = option.series[hoveredIndex].pieStatus.k;
        // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
        option.series[hoveredIndex].parametricEquation = getParametricEquation(
          startRatio,
          endRatio,
          isSelected,
          isHovered,
          k,
          option.series[hoveredIndex].pieData.value,
        );
        option.series[hoveredIndex].pieStatus.hovered = isHovered;
        // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
        hoveredIndex = '';
      }
      // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
      if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
        // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
        isSelected = option.series[params.seriesIndex].pieStatus.selected;
        isHovered = true;
        startRatio = option.series[params.seriesIndex].pieData.startRatio;
        endRatio = option.series[params.seriesIndex].pieData.endRatio;
        k = option.series[params.seriesIndex].pieStatus.k;
        // 对当前点击的扇形，执行高亮操作（对 option 更新）
        option.series[params.seriesIndex].parametricEquation = getParametricEquation(
          startRatio,
          endRatio,
          isSelected,
          isHovered,
          k,
          option.series[params.seriesIndex].pieData.value + 5,
        );
        option.series[params.seriesIndex].pieStatus.hovered = isHovered;
        // 记录上次高亮的扇形对应的系列号 seriesIndex
        hoveredIndex = params.seriesIndex;
      }
      // 使用更新后的 option，渲染图表
      myChart.setOption(option);
    }
  });
  // 修正取消高亮失败的 bug
  myChart.on('globalout', function () {
    let option = myChart.getOption()
    // 准备重新渲染扇形所需的参数
    let isSelected;
    let isHovered;
    let startRatio;
    let endRatio;
    let k;
    if (hoveredIndex !== '') {
      // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
      isSelected = option.series[hoveredIndex].pieStatus.selected;
      isHovered = false;
      k = option.series[hoveredIndex].pieStatus.k;
      startRatio = option.series[hoveredIndex].pieData.startRatio;
      endRatio = option.series[hoveredIndex].pieData.endRatio;
      // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
      option.series[hoveredIndex].parametricEquation = getParametricEquation(
        startRatio,
        endRatio,
        isSelected,
        isHovered,
        k,
        option.series[hoveredIndex].pieData.value,
      );
      option.series[hoveredIndex].pieStatus.hovered = isHovered;
      // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
      hoveredIndex = '';
    }
    // 使用更新后的 option，渲染图表
    myChart.setOption(option);
  });
}
